<template>
  <div class="lifecycle-page" role="status" aria-live="polite">
    <div class="lifecycle-card">
      <img :src="brand.assets.logoMark" alt="" class="lifecycle-logo" />
      <span class="lifecycle-spinner" aria-hidden="true"></span>
      <h1>Preparing your workspace</h1>
      <p>Loading your modules and access settings.</p>
    </div>
  </div>
</template>

<script>
import { onMounted, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import brand from "@/whitelabel/brand.config";

export default {
  name: "LoadingHome",
  setup() {
    const router = useRouter();
    let redirectTimer = null;

    onMounted(() => {
      document.title = `Loading | ${brand.productName}`;
      redirectTimer = window.setTimeout(() => router.push({ name: "home" }), 2000);
    });

    onUnmounted(() => window.clearTimeout(redirectTimer));

    return { brand };
  },
};
</script>

<style scoped>
.lifecycle-page {
  align-items: center;
  background: var(--ui-muted);
  display: flex;
  inset: 0;
  justify-content: center;
  min-height: 100vh;
  padding: 1.25rem;
  position: fixed;
  z-index: 999;
}
.lifecycle-card {
  align-items: center;
  background: var(--ui-card);
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius);
  box-shadow: var(--ui-shadow-sm);
  color: var(--ui-card-foreground);
  display: flex;
  flex-direction: column;
  max-width: 24rem;
  padding: 2.25rem;
  text-align: center;
  width: 100%;
}
.lifecycle-logo { height: 3rem; margin-bottom: 1.5rem; width: 3rem; }
.lifecycle-spinner {
  animation: lifecycle-spin 750ms linear infinite;
  border: 3px solid var(--ui-border);
  border-radius: 50%;
  border-top-color: var(--ui-primary);
  height: 2.5rem;
  width: 2.5rem;
}
.lifecycle-card h1 { font-size: 1.15rem; font-weight: 700; margin: 1.25rem 0 0; }
.lifecycle-card p { color: var(--ui-muted-foreground); font-size: 0.84rem; margin: 0.45rem 0 0; }
@keyframes lifecycle-spin { to { transform: rotate(360deg); } }
@media (prefers-reduced-motion: reduce) { .lifecycle-spinner { animation-duration: 1.5s; } }
</style>
